<!-- DOVE-2155 — inline past-date confirmation (matches Client Portal date-validation style). -->
<div *ngIf="show" class="border-1 border-orange-300 bg-orange-50 border-round p-3 mt-2">
	<div class="flex align-items-start gap-2">
		<i class="pi pi-exclamation-triangle text-orange-600 mt-1"></i>
		<div>
			<div class="font-semibold text-sm text-orange-900">Past date selected</div>
			<div class="text-sm text-orange-800 mt-1">
				This order is scheduled for <strong>{{ formattedDate }}</strong
				>, which is in the past. Please confirm this is intentional.
			</div>
			<div class="flex align-items-center gap-2 mt-2">
				<p-checkbox
					[formControl]="confirmControl"
					[binary]="true"
					[inputId]="inputId"
					styleClass="checkbox-pointer"
				></p-checkbox>
				<label [for]="inputId" class="text-sm text-orange-900 cursor-pointer">
					I confirm the scheduled date is correct.
				</label>
			</div>
		</div>
	</div>
</div>
